import axios, { AxiosInstance } from 'axios';

const ENV_CONFIG = {
    development: '',
    production: import.meta.env.VITE_API_URL || '',
};

export const getCurrentEnv = (): 'development' | 'production' => {
    return import.meta.env.DEV ? 'development' : 'production';
};

export const getBaseURL = (): string => ENV_CONFIG[getCurrentEnv()];

export const request: AxiosInstance = axios.create({
    baseURL: getBaseURL(),
    timeout: 30000,
    headers: { 'Content-Type': 'application/json' },
});

request.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error),
);

request.interceptors.response.use(
    (response) => {
        const { code, data, msg } = response.data;
        if (+code === 0 || +code === 200) return data;
        return Promise.reject(new Error(msg || '请求失败'));
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('userInfo');
            import('element-plus').then((ElementPlus) => {
                ElementPlus.ElMessage.error('登录已过期，请重新登录');
            });
            import('@/router/index').then(({ default: router }) => {
                router.push({
                    path: '/login',
                    query: {
                        redirect: window.location.hash.replace('#', ''),
                    },
                });
            });
            return Promise.reject(new Error('未授权，请重新登录'));
        }
        // 业务错误统一弹 ElMessage 提示
        const errorMsg =
            error.response?.data?.msg || error.message || '请求失败';
        import('element-plus').then((ElementPlus) => {
            ElementPlus.ElMessage.error(errorMsg);
        });
        return Promise.reject(new Error(errorMsg));
    },
);

export default request;
